"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.base62ToBase10 = base62ToBase10;
exports.base10ToBase62 = base10ToBase62;
exports.isValidBase62String = isValidBase62String;
const BASE62_CHARS = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
function base62ToBase10(base62) {
    let num = BigInt(0);
    const base = BigInt(62);
    for (let i = 0; i < base62.length; i++) {
        num = num * base + BigInt(BASE62_CHARS.indexOf(base62[i]));
    }
    return num;
}
function base10ToBase62(num) {
    if (num === BigInt(0))
        return BASE62_CHARS[0];
    let base62 = "";
    const base = BigInt(62); // Use BigInt for the base value
    while (num > BigInt(0)) {
        const remainder = num % base;
        base62 = BASE62_CHARS[Number(remainder)] + base62; // Convert BigInt to number for indexing
        num = num / base; // Division with BigInt
    }
    return base62;
}
function isValidBase62String(base62) {
    const base62Reg = /^[0-9a-zA-Z]+$/;
    return base62Reg.test(base62);
}
//# sourceMappingURL=base62.js.map